import React, { Component } from "react";
import { connect } from "react-redux";
import ErrorAction from "../../../Redux/ErrorRedux";
import Container from "../../../modules/commons/Container";
import ManagementBookingSearch from "./components/managementBookingSearch";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import {
  formGroup,
  INITIAL_DATE,
  INITIAL_PAGINATION,
  mainPageTableConfig,
} from "./config";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import { defaultTableChange } from "../../../modules/custom/customTable";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { ACTIVITY_TYPE, HttpStatus } from "../../common/Constants";
import FlexView from "react-flexview";
import { fetchDataAsync, getUserAccess } from "../../../Services/Utils";
import Api from "../../../Services/Api";
import { mapToObjectDDL, removeNullFields } from "../../common/mapper";
import ManagementBookingDetail from "./components/managementBookingDetail";
import { constructPayloadCetak } from "./service";
import { saveAs } from "file-saver";
import ManagementBookingFilter from "./components/managementBookingFilter";

class ManagementBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      cabangOptions: [],
      search: {
        startBookingDate: INITIAL_DATE,
        endBookingDate: INITIAL_DATE,
        selectedCabang: null,
      },
      filterVisible: false,
      loading: false,
      alertInfo: {
        type: null,
        content: null,
        title: null,
        visible: false,
      },
      pagination: INITIAL_PAGINATION,
      userAccess: null,
      detail: {
        visible: false,
        selectedId: null,
      },
      skipNextFetch: false,
      submitedFilter: null,
      activityType: null,
      formGroupState: formGroup,
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
  }

  componentDidUpdate(prevProps, prevState) {
    const currCabang = this.state.search.selectedCabang?.value;
    const prevCabang = prevState.search.selectedCabang?.value;
    if (currCabang !== prevCabang) {
      this.setState((prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          page: 1,
          limit: 5,
        },
        skipNextFetch: true,
        search: {
          ...prev.search,
          startBookingDate: INITIAL_DATE,
          endBookingDate: INITIAL_DATE,
        },
        submitedFilter: null,
      }));

      this.fetchDataMainPage(
        {
          startBookingDate: INITIAL_DATE,
          endBookingDate: INITIAL_DATE,
        },
        5,
        1,
      );
    }

    const currPage = this.state.pagination;
    const prevPage = prevState.pagination;

    if (
      (currPage.page !== prevPage.page || currPage.limit !== prevPage.limit) &&
      !this.state.skipNextFetch
    ) {
      this.fetchDataMainPage(
        {
          startBookingDate: this.state.search.startBookingDate,
          endBookingDate: this.state.search.endBookingDate,
          ...this.state.submitedFilter,
        },
        currPage.limit,
        currPage.page,
      );
    }
    if (this.state.skipNextFetch) {
      this.setState({ skipNextFetch: false });
    }
  }

  handleRefreshPagination = () => {
    this.setState(
      (prev) => ({
        ...prev,
        skipNextFetch: true,
      }),
      () => {
        this.fetchDataMainPage(
          {
            startBookingDate: this.state.search.startBookingDate,
            endBookingDate: this.state.search.endBookingDate,
            ...this.state.submitedFilter,
          },
          this.state.pagination.limit,
          this.state.pagination.page,
        );
      },
    );
  };

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "Management Booking",
      args: null,
    });
    if (res.ok) {
      const filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang),
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          cabangOptions: filteredData.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang),
          ),
          search: {
            ...prevValue.search,
            selectedCabang: mapToObjectDDL(
              filteredData[0].namaDealer,
              filteredData[0].kodeCabang,
            ),
          },
          userAccess: getUserAccess(
            this.props.menuAccess,
            filteredData[0].kodeCabang,
          ),
        }));
      }
    }
    this.handleTriggerLoading();
  };

  fetchDataMainPage = async (filter = {}, limit, page) => {
    const { pagination, search } = this.state;
    this.handleTriggerLoading();
    const payload = {
      ...filter,
      limit: limit || pagination.limit,
      page: page || pagination.page,
      kodeCabang: search.selectedCabang?.value,
    };
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getDataManagementBooking,
      setError: this.props.setError,
      menuName: "Management Booking",
      args: removeNullFields(payload),
    });
    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
  };

  handleChangeSearch = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      search: {
        ...prev.search,
        [name]: value,
      },
    }));
  };

  handleSearch = () => {
    this.setState(
      (prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          page: 1,
        },
        skipNextFetch: true,
      }),
      () => {
        this.fetchDataMainPage(
          {
            startBookingDate: this.state.search.startBookingDate,
            endBookingDate: this.state.search.endBookingDate,
          },
          this.state.pagination.limit,
          1,
        );
      },
    );
  };

  handleFilterVisibility = () => {
    this.setState((prev) => ({
      ...prev,
      filterVisible: !prev.filterVisible,
    }));
  };

  handleDetailVisibility = (id, activityType) => {
    const isUpdate = activityType === ACTIVITY_TYPE.UPDATE;
    this.setState((prev) => ({
      ...prev,
      detail: {
        ...prev.detail,
        selectedId: id,
        visible: !prev.detail.visible,
      },
      activityType: activityType,
      formGroupState: isUpdate
        ? {
            ...prev.formGroupState,
            bookingStatus: { value: null, mandatory: true },
          }
        : prev.formGroupState,
    }));
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({
      ...prev,
      loading: !prev.loading,
    }));
  };

  handleChangePage = (tableState) => {
    const page = tableState.page + 1;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: page,
      },
    }));
  };

  handleChangeRowsPerPage = (tableState) => {
    const limit = tableState.rowsPerPage;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit: limit,
      },
    }));
  };

  handlePrint = async () => {
    this.handleTriggerLoading();
    const payload = constructPayloadCetak({
      ...this.state.search,
      ...this.state.submitedFilter,
      ...this.state.pagination,
    });
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION_FILE")
        .printExcelManagementBooking,
      setError: this.props.setError,
      menuName: "Management Booking",
      args: payload,
    });
    this.handleTriggerLoading();
    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "DATA_BOOKING.xlsx");
    }
  };

  getTableValue = () => {
    return mainPageTableConfig({
      userAccess: this.state.userAccess,
      onClick: this.handleDetailVisibility,
    });
  };

  handleSubmitFilter = (payload) => {
    this.setState(
      (prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          page: 1,
        },
        skipNextFetch: true,
        search: {
          ...prev.search,
          startBookingDate: null,
          endBookingDate: null,
        },
        submitedFilter: payload,
      }),
      () => {
        this.fetchDataMainPage(payload, this.state.pagination.limit, 1);
      },
    );
  };

  render() {
    const {
      dataTable,
      search,
      cabangOptions,
      loading,
      pagination,
      userAccess,
      detail,
      filterVisible,
      submitedFilter,
      activityType,
      formGroupState,
    } = this.state;
    
    return (
      <React.Fragment>
        <Container>
          <ManagementBookingSearch
            {...search}
            cabangOptions={cabangOptions}
            onSearchChange={this.handleChangeSearch}
            onSearch={this.handleSearch}
            onFilterClick={this.handleFilterVisibility}
          />
          <SimpleDataTable
            key={`${pagination.totalData}-${pagination.page}`}
            columns={this.getTableValue()}
            data={dataTable}
            toCount={pagination.totalData}
            rowsPerPage={pagination.limit}
            page={pagination.page - 1}
            options={defaultTableChange(
              this.handleChangePage,
              this.handleChangeRowsPerPage,
            )}
            footerAdditionalButtons={
              <FlexView vAlignContent="center" style={{ gap: "5px" }}>
                <SimpleButton
                  type="button"
                  text="Tambah"
                  secondary={!userAccess?.createAccess}
                  disabled={!userAccess?.createAccess}
                  icon={<i className="fa fa-plus margin margin-right-5px" />}
                  onClick={() =>
                    this.handleDetailVisibility(null, ACTIVITY_TYPE.CREATE)
                  }
                />
                <SimpleButton
                  type="button"
                  text="Cetak"
                  onClick={this.handlePrint}
                />
              </FlexView>
            }
          />
        </Container>
        {loading && <SimpleLoadingOverlay active={loading} />}
        {detail.visible && (
          <ManagementBookingDetail
            {...this.props}
            detail={detail}
            initialValues={detail.selectedId}
            cabangOptions={cabangOptions}
            formGroup={formGroupState}
            selectedCabang={search.selectedCabang}
            visible={detail.visible}
            activityType={activityType}
            onRefresh={this.handleRefreshPagination}
            onTriggerLoading={this.handleTriggerLoading}
            onClickClose={this.handleDetailVisibility}
          />
        )}
        {filterVisible && (
          <ManagementBookingFilter
            visible={filterVisible}
            submitedFilter={submitedFilter}
            onClickClose={this.handleFilterVisibility}
            onSubmitFilter={this.handleSubmitFilter}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(ManagementBooking);
